module.exports = __webpack_public_path__ + "static/img/red cancel.96d35f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/red cancel.png
// module id = 0Faa
// module chunks = 1